// extracted by mini-css-extract-plugin
module.exports = {"subsection":"src-components-Subsection-styles___subsection"};